import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import hayatin from '../../assets/images/hayatin.jpg';
// import homeicon from '../../assets/home-images/homeicon.jpg';
// import experienceicon from '../../assets/home-images/experienceicon.jpg';
import search from '../../assets/home-images/search.png';
import downarrow from '../../assets/home-images/downarrow.png';
// import homeicon from '../../assets/home-images/homeicon.jpg';
// import experienceicon from '../../assets/home-images/experienceicon.jpg';
// import businessicon from '../../assets/home-images/businessicon.jpg';
import Navbar from "../common-component/navbar/Navbar";
const PrivacyPolicy = () => {

    const [showPopup, setShowPopup] = useState(false);
    const [language, setLanguage] = useState("english");
    const location = useLocation();
    const togglePopup = () => setShowPopup(!showPopup);

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
        setShowPopup(false);
    };


    return (
        <div>
            <Navbar />

            <div className="experience-main-layout">
                <aside className="left-section" dir={language === "arabic" ? "rtl" : "ltr"}>
                    <div className="searchbox">
                        <img src={search} alt="search" />
                        <input type="text" placeholder="Search..." />
                    </div>
                    <div className="left-menu-content">
                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/merchantagreement" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/merchantagreement" className="no-underline">
                                <p>Service Provider Agreement</p>
                            </Link>
                        </div>

                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/submissionguidelines" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/submissionguidelines" className="no-underline">
                                <p>Submission Guidelines</p>
                            </Link>
                        </div>
                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/privacypolicy" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/privacypolicy" className="no-underline">
                                <p>Privacy Policy</p>
                            </Link>
                        </div>

                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/termsofuseforusers" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/termsofuseforusers" className="no-underline">
                                <p>Terms Of Use For Users</p>
                            </Link>
                        </div>
                        <div
                            className="agreement-contentname"
                            style={{
                                backgroundColor: location.pathname === "/ruleofuse" ? "#ECF3FF" : "transparent"
                            }}
                        >
                            <Link to="/ruleofuse" className="no-underline">
                                <p>Rule Of Use</p>
                            </Link>
                        </div>

                    </div>
                    <div className="divider-line"></div>
                    <div className="footer-links">
                        <div className="footer-column">
                            <span>About</span>
                            {/* <span>Business Pro</span> */}
                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                        </div>
                        {/* <div className="footer-column">
                                           <span>Help Center</span>
                                           <span>FAQ</span>
                                           <span>Careers</span>
                                       </div> */}
                        <div className="footer-column">

                            <div className="content-arrow" onClick={togglePopup}>
                                <span className="language-text">
                                    {language === "english" ? "Language" : "اللغة"}
                                </span>
                                <img src={downarrow} alt="down arrow" className="arrow-icon" />

                                {showPopup && (
                                    <div className="language-popup">
                                        <label>
                                            <input
                                                type="radio"
                                                name="language"
                                                value="english"
                                                checked={language === "english"}
                                                onChange={() => handleLanguageChange("english")}
                                            />
                                            English
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="language"
                                                value="arabic"
                                                checked={language === "arabic"}
                                                onChange={() => handleLanguageChange("arabic")}
                                            />
                                            Arabic
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                </aside>


                <main className="merchant-mid-section-container" >
                    <div className="agreement-heading">
                        <h4>
                            Privacy Policy/ Hayat In L.L.C- S.P.C
                        </h4>
                    </div>

                    <div className="merchant-mid-section-body">
                        <div className="agreement-subheading">
                            <h5>
                                This policy is effective as of Feb 1, 2025
                            </h5>

                            <h5>
                                Introduction
                            </h5>
                            <p>
                                This Privacy Notice elucidates how Hayat In L.L.C- S.P.C and its affiliated companies utilize your information.
                                It applies to all users of our websites and platforms, encompassing mobile applications, electronic services, social networking sites, interactive features, and online services.
                                If you engage with our services ("Service"), kindly review the  <a href="#privacy policy" className="hayat-link">Terms of Use</a> governing your Service usage. By using the Service, you affirm that you have perused and comprehended this Privacy Notice. If you disagree with this Privacy Notice, please refrain from providing us with your information or utilizing the Service.
                            </p>

                            <p>
                                We retain the right to modify this Privacy Policy at any time.
                                In the event of significant changes, we will apprise you via email (dispatched to the email address in your account) or through a notice on the Service before the modification takes effect. The "Effective Date" above denotes the last revision date for this Privacy Policy.
                            </p>
                            <p>
                                At Hayat In L.L.C- S.P.C, we hold the privacy of our website visitors in high regard. This Privacy Policy delineates the types of information Hayat In L.L.C- S.P.C collects and records, along with its utilization.
                            </p>
                            <p>
                                For any queries about our Privacy Policy or if you need further clarification, please don't hesitate to get in touch with us at <a href="mailto:Info@hayatinapp.com" className="email-link">Info@hayatinapp.com</a>
                            </p>
                            <p>
                                Kindly note that this policy pertains exclusively to our online activities and is relevant solely to information shared and collected on Hayat In L.L.C- S.P.C 's website.
                                It does not extend to information collected through other channels.
                            </p>
                            <p>
                                Hayat In L.L.C- S.P.C, its subsidiaries, and affiliates globally (referred to collectively as "Hayat In L.L.C- S.P.C," "Company," "we," or "our") recognize the significance of protecting privacy for all users ("you") who visit and utilize our websites. This includes registered users or guests and encompasses any content, functionality, and services provided on or through our websites, webpages, and mobile applications designed for dedicated non-browser-based interaction on smartphones, tablets, and other devices ("Sites").
                            </p>
                            <p>
                                This Privacy Policy elucidates our rationale for collecting and processing your personal information, as well as our practices for collecting, using, maintaining, retaining, protecting, and disclosing your personal data when you visit any of our Sites, irrespective of your location. Additionally, it apprises you of your privacy rights and the legal safeguards protecting these rights.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>
                                Consent
                            </h6>
                            <p>
                                By using our website, you hereby consent to our Privacy Policy and agree to its terms.
                            </p>
                            <h6>1. Types of Information We Collect</h6>
                            <p>
                                Personal data, or information that can identify an individual, is encompassed within this term. It excludes data where the identity has been removed, rendering it anonymous. Depending on the products/services you use and your interactions with our Sites, we collect various types of information from or about you. This includes, but is not limited to, the following categories of personal data:
                            </p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent" >
                                    <span> •</span>
                                    <p>
                                        Identity Data: Includes first name, last name, address, username, marital status, title, age group, and gender.
                                    </p>
                                </div>
                                <div className="defined-terms-listcontent" >
                                    <span> •</span>
                                    <p>
                                        Contact Data: Encompasses billing address, delivery address, location, email address, and/or telephone numbers.</p>
                                </div>
                                <div className="defined-terms-listcontent" >
                                    <span> •</span>
                                    <p>Financial Data: Comprises payment card details and payment history. </p>
                                </div>

                                <div className="defined-terms-listcontent" >
                                    <span> •</span>
                                    <p>Transaction Data: Involves details about payments to and from you, as well as information about products and services purchased. </p>
                                </div>

                                <div className="defined-terms-listcontent" >
                                    <span> •</span>
                                    <p>
                                        Technical Data: Encompasses IP address, login data, browser type and version, device details, operating system, hardware version, platform, file and software names, device identifiers, time zone settings, and location.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent" >
                                    <span> •</span>
                                    <p>
                                        Profile Data: Includes your username and password, purchases, interests, preferences, feedback, and survey responses.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Usage Data: Encompasses information about how you use our Sites, products, and services, including the redemption of offers and device usage patterns.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Other Data: Encompasses photos or data uploaded to our Sites, communications with us via various channels, third-party partner information, and networks and connections available to us.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Marketing and Communications Data: Encompasses your preferences in receiving marketing and your communication preferences.
                                    </p>
                                </div>


                            </div>
                            <p>
                                We also collect, use, and share aggregated data, such as statistical or demographic data, for various purposes. Aggregated Data, derived from personal data but not considered personal data in law, may be used for statistical analysis. If aggregated data is combined with personal data to identify you directly or indirectly, it is treated as personal data in accordance with this Privacy Policy.
                            </p>
                            <p>
                                We do not collect Special Categories of Personal Data, such as philosophical beliefs, sex life, sexual orientation, political opinions, trade union membership, health information, genetic and biometric data, criminal convictions, or offenses.
                            </p>

                            <p>
                                Types of Information We Collect
                            </p>
                            <p>
                                We may collect the following categories of personal information:
                            </p>

                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Identifiers: Such as names, addresses, email addresses, telephone numbers, or other communication addresses.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Demographic Information: Including age group, birthdate, and gender.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Commercial Information: Relevant to lifestyle, interests, activities, purchasing tendencies, and order history.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Location Information: Including country, city, or neighborhood, and more specific location information provided through GPS functionality.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Financial Information: Collected for processing payments, encompassing payment card details.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Internet and Network Activity Information: Covering browsing behavior, search history, and interactions with websites and advertisements.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Inferences Regarding Preferences: Assessments of products or services of interest.
                                    </p>
                                </div>

                            </div>

                            <p>
                                The personal information you are asked to provide and the reasons for providing it will be transparent at the point of collection. If you contact us directly, we may receive additional information, such as your name, email address, phone number, message content, and attachments. During account registration, we may request contact information, including name, company name, address, email address, and telephone number.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>
                                FAILURE TO PROVIDE PERSONAL DATA
                            </h6>
                            <p>
                                If personal data is required by law or under a contract, and you fail to provide it when requested, we may be unable to perform the contract or fulfill your requests.
                            </p>
                            <h6>2. How Hayat In L.L.C- S.P.C Gathers Information</h6>

                            <p>
                                Information Collection from Various Sources:
                            </p>

                            <p>1. Direct Submission:</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Information provided by you during Service usage, purchases, registration, or interaction.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Voluntarily entered information in postings, comments, or forums within the Service.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Collected details from emails, including your email address and content.
                                    </p>
                                </div>

                            </div>

                            <p>2. Device Information:</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Collected details about the devices used to access the Service, such as hardware model, operating system, IP address, and device interaction.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Information on access times, browser types, and language through the use of cookies, web beacons, and similar technologies.
                                    </p>
                                </div>
                            </div>

                            <p>3. Location Information:</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Collection of location information, including general details associated with your IP address and specific information from GPS functionality (if agreed).
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Utilization of location data to customize the Service, potentially shared with affiliates, agents, vendors, or advertisers.
                                    </p>
                                </div>
                            </div>

                            <p>4. Third-Party Sources:</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Obtaining information from third-party sources like vendors, web hosting providers, analytics providers, or advertisers.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Accessing information from third-party services with your permission, such as social media networks.
                                    </p>
                                </div>
                            </div>

                            <p>Methods of Data Collection:</p>
                            <p>1. Direct Interactions:</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Provision of Identity, Contact, and Financial Data through forms, correspondence, purchases, account creation, subscriptions, requests, competitions, or surveys.
                                    </p>
                                </div>
                            </div>

                            <p>2. Automated Technologies or Interactions:</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Automatic collection of Technical Data through cookies, server logs, web beacons, and similar technologies.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Categorized cookies for various purposes: strictly necessary, performance, functionality, and targeting/advertising.
                                    </p>
                                </div>
                            </div>

                            <p>3. Third Parties or Publicly Available Sources:</p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Receipt of personal data from third parties such as analytics providers, advertising networks, search information providers, and contracted third parties.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Reception of Contact, Financial, and Transaction Data from providers of technical, payment, and delivery services.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Collection of Identity and Contact Data from data brokers or aggregators and publicly available sources.
                                    </p>
                                </div>
                            </div>

                            <p>Note: Personal information collected automatically may be linked to information obtained from other sources or provided by you.</p>

                            <h6>3. How Hayat In L.L.C- S.P.C Utilizes and Use Your Information</h6>

                            <p>
                                <span style={{ fontWeight: "600" }}>Utilization and use of Collected Information</span>: We employ the information gathered in diverse ways, including but not limited to:
                            </p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Operating and maintaining our website.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Enhancing, customizing, and expanding our website.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Analyzing your website usage patterns.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Developing new products, services, features, and functionalities.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Communicating with you directly or through partners for customer service, updates, marketing, and promotional purposes.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Sending emails and preventing fraud.
                                    </p>
                                </div>
                            </div>

                            <p>
                                <span style={{ fontWeight: "600" }}>Application of Information as per Privacy Notice</span>: We may use the information collected as outlined in this Privacy Notice to:
                            </p>

                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Operate, maintain, and enhance the Service and related features.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Provide interest-based ads, push notifications, communications, and offers, considering your precise geolocation.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Facilitate and fulfill orders, including tracking redemption, for Hayat In L.L.C- S.P.C vouchers and other goods and services.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Process and confirm bookings with partners and handle payments.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Assess eligibility for offers, products, or services, and evaluate advertising effectiveness.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Address inquiries, respond to requests, perform analytics, and conduct customer research.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Communicate information about Hayat In L.L.C- S.P.C and business partners, sometimes by combining data from various sources.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Send reminders, technical notices, updates, security alerts, support messages, marketing content, and requested information.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Administer rewards, surveys, sweepstakes, contests, or promotional activities.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Manage routine business operations, including administration, forum management, fulfillment, analytics, fraud prevention, and compliance with corporate reporting obligations and Terms of Use.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Enable job applications, video posting, or sign-ups for special offers.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Verify requests made under this Privacy Notice.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Enhance existing information to better understand your interests.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Use your data in accordance with the Card Linked Deals program if you've consented to participate.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Additionally, we may use information with your consent or as required/permitted by law.
                                    </p>
                                </div>
                            </div>

                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>Geolocation Usage: </span>
                                Hayat In L.L.C- S.P.C employs your geolocation, including precise details, to deliver location-based offers, products, or services as described in Section 2 above.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>Password-Linked Purchases: </span>
                                For purchases made without a password, we link them to your email address, creating a secure account. If you later create a password, you can view past purchases associated with that email address.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>Information Sharing: </span>
                                If you use Service features to send information about a product or service to another person, we collect their personal information to the extent disclosed by you and may contact them using the provided information.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>Legal Basis for Data Processing: </span>
                                We use your personal data in compliance with the law, typically for contract performance, legitimate interests, legal obligations, or with your consent. Consent is primarily sought for third-party direct marketing communications, and you can withdraw it at any time.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>Log Files: </span>
                                Hayat In L.L.C- S.P.C follows standard log file procedures, collecting information such as IP addresses, browser type, ISP, date and time stamp, referring/exit pages, and clicks for analytics. This data is not linked to personally identifiable information and is used for trend analysis, site administration, tracking user movement, and demographic information gathering.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>Cookies and Web Beacons: </span>
                                Like other websites, Hayat In L.L.C- S.P.C uses cookies to store visitor preferences and track accessed pages. This information optimizes user experience by customizing webpage content based on browser type and other details.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>Advertising Partners' Privacy Policies: </span>
                                Refer to the Privacy Policy of each advertising partner on the provided list for detailed information. Third-party ad servers or networks use technologies like cookies, JavaScript, or Web Beacons to measure advertising campaign effectiveness and personalize content based on users' IP addresses. Hayat In L.L.C- S.P.C has no control over these third-party advertisers' cookies.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>Third-Party Privacy Policies: </span>
                                Hayat In L.L.C- S.P.C's Privacy Policy doesn't apply to other advertisers or websites. Consult the respective Privacy Policies of third-party ad servers for more information, including practices and opt-out instructions.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>Privacy Rights: </span>
                                Consumers have rights, including accessing, deleting, and opting out of personal data sales. Requests receive a one-month response time. Contact us to exercise these rights.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>GDPR Data Protection Rights: </span>
                                Users have rights, including access, rectification, erasure, processing restriction, objection, and data portability. Requests receive a one-month response time. Contact us to exercise these rights.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>Children's Information: </span>
                                Our priority includes protecting children online. Hayat In L.L.C- S.P.C does not knowingly collect Personal Identifiable Information from children under 13. If your child provides such information, contact us for prompt removal from our records.
                            </p>

                            <h6>4.	When and Why Hayat In L.L.C- S.P.C Shares Information</h6>
                            <p>
                                Hayat In L.L.C- S.P.C may disclose your personal information in the following circumstances:
                            </p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent" >
                                    <p style={{ fontWeight: "600" }}>
                                        •	Legal Compliance and Governance:
                                    </p>
                                </div>
                                <p>
                                    To comply with the law, legal orders, and government requests, or to support auditing, compliance, and corporate governance functions.
                                </p>

                                <div className="defined-terms-listcontent">
                                    <p style={{ fontWeight: "600" }}>• Legal Processes:</p>
                                </div>
                                <p>
                                    In response to a subpoena or similar legal process, including sharing with law enforcement agencies, regulators, and courts in the United Arab Emirates and other countries where operations are conducted.
                                </p>

                                <div className="defined-terms-listcontent">
                                    <p style={{ fontWeight: "600" }}>• Service Providers:</p>
                                </div>
                                <p>
                                    Vendors provide various services, such as data storage, order fulfillment, email transmission, and digital content management. This sharing is subject to confidentiality obligations consistent with this Privacy Notice and with the condition that service providers use your information solely on our behalf and according to our instructions.
                                </p>

                                <div className="defined-terms-listcontent">
                                    <p style={{ fontWeight: "600" }}>• Merchant Collaboration:</p>
                                </div>
                                <p>
                                    With merchants to deliver the services you request, facilitate and fulfill orders, and process and confirm bookings.
                                </p>

                                <div className="defined-terms-listcontent">
                                    <p style={{ fontWeight: "600" }}>• Business Transitions:</p>
                                </div>
                                <p>
                                    During business transitions such as mergers, acquisitions, bankruptcy, reorganization, or sale of assets (as outlined in Section 10).
                                </p>

                                <div className="defined-terms-listcontent">
                                    <p style={{ fontWeight: "600" }}>• Fraud Protection and Legal Proceedings:</p>
                                </div>
                                <p>
                                    To combat fraud, criminal activity, and protect our rights, users, and business partners, or as part of legal proceedings affecting Hayat In L.L.C- S.P.C.
                                </p>

                                <div className="defined-terms-listcontent">
                                    <p style={{ fontWeight: "600" }}>• Affiliate Sharing:</p>
                                </div>
                                <p>
                                    With affiliates and subsidiaries using personal information only for the purposes described in this Privacy Notice.
                                </p>



                                <div className="defined-terms-listcontent">

                                    <div className="defined-terms-text">
                                        <p style={{ fontWeight: "600" }}>• Affiliate Sharing:</p>

                                        <div className="inner-content-5th-term">
                                            <p>
                                                1. If the information has been aggregated, de-identified, or otherwise does not personally identify you.
                                            </p>
                                            <p>
                                                2.	Otherwise, with your consent.
                                            </p>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>• Categories of Third Parties:  </span>
                                The personal information may be disclosed to various third-party categories, including:
                            </p>

                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Hayat In L.L.C- S.P.C entities</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Merchants</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Co-marketers</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Distributors</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Resellers</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Advertising Networks</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Payment Services Providers</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Internet Service Providers</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Data Analytics Providers</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Operating Systems and Platforms</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Social Networks</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Government or Law Enforcement Entities</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Fraud Protection and Prevention Providers</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Delivery Services Providers</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Service Providers</p>
                                </div>
                            </div>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>• Categories of Personal Information Disclosed: </span>
                                For business and operational purposes within the 12 months preceding this Privacy Notice's Effective Date, Hayat In L.L.C- S.P.C may disclose the following categories of personal information:
                            </p>

                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Identifiers</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Demographics</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Commercial information</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Location information</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Financial information</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Internet and network activity information</p>
                                </div>
                                <div className="defined-terms-listcontent">
                                    <p><span style={{ marginRight: "13px" }}>✓</span>Inferences regarding preferences or characteristics</p>
                                </div>
                            </div>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>• Data Sharing for Consideration: </span>
                                Certain personal information may be disclosed in exchange for services, insights, or other valuable considerations, involving the same categories mentioned above, and such disclosures have occurred in the 12 months before this Privacy Notice's Effective Date.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>• Third-Party Data Sharing: </span>
                                Hayat In L.L.C- S.P.C may share your personal data with various parties, including Internal Third Parties, External Third Parties, third parties specified in Section 4 – How we use your Personal Data above, and third parties to whom we may sell, transfer, or merge parts of our business or assets. If a change occurs in our business, the new owners may use your personal data in line with this Privacy Policy.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <p>
                                <span style={{ fontWeight: "600" }}>• Security and Processing Instructions: </span>
                                We mandate that all third parties respect the security of your personal data, treat it in accordance with the law, and process it only for specified purposes and in line with our instructions.
                            </p>

                            <h6>5. Security of Personal Information</h6>
                            <p>
                                Hayat In L.L.C- S.P.C has established a comprehensive information security program that includes administrative, technical, and physical controls to reasonably safeguard personal information. Financial account information is secured using industry-standard encryption technology. However, it's important to note that no method of transmission over the Internet or electronic storage is entirely foolproof.
                                If you have any concerns regarding the security of our website, please don't hesitate to contact us at  <a href="mailto:Info@hayatinapp.com" className="email-link">Info@hayatinapp.com</a>
                            </p>
                            <p>
                                We have put in place appropriate security measures to prevent accidental loss, unauthorized access, alteration, or disclosure of your personal data. Access to your personal data is limited to employees, agents, contractors, and other third parties with a business need to know. They process your personal data solely based on our instructions and are bound by a duty of confidentiality.
                            </p>
                            <p>
                                Procedures are in place to deal with any suspected breaches of personal data, and we will notify you and relevant regulators of any breaches as required by law.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>6. Retention of Personal Data:</h6>
                            <p>
                                We will keep your personal data for as long as your account is active or as necessary to provide you with our services.
                                If you decide to close your account, we will continue to keep your personal data for as long as it is essential for the effective operation of our business.
                                This includes keeping a record of your transactions for financial reporting or fraud prevention purposes until such purposes cease to exist.
                                Moreover, we will retain your data as required to fulfill legal obligations, resolve disputes, and enforce our agreements.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>Duration of Personal Data Usage:</h6>
                            <p>
                                We will use your personal data only for as long as it is necessary to achieve the purposes for which it was collected.
                                This includes satisfying legal, accounting, or reporting requirements.
                                The appropriate retention period will depend on various factors such as the quantity, nature, and sensitivity of the personal data, potential risks of unauthorized use or disclosure, the purposes of data processing, alternative means to achieve those purposes, and compliance with applicable legal requirements.
                            </p>
                            <p>
                                Under certain circumstances, we may anonymize your personal data for research or statistical purposes.
                                This will make it unassociated with you. In such cases, this anonymized information may be used indefinitely for these purposes without further notice to you.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>7. Your Entitlements Concerning Personal Information</h6>
                            <p>
                                You possess specific rights regarding your personal information:
                            </p>
                            <p>
                                You have the right to inquire and request information about the categories and specific pieces of personal information collected about you in the last 12 months. This includes details on the sources of such information, the purpose behind its collection, and the categories of third parties with whom we share it. You also have the right to know if:
                            </p>

                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Your personal information has been sold or disclosed for business purposes.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        The ability to update your personal information.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        You can request a portable copy of your personal information.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        You have the right to request the deletion of your personal information by Hayat In L.L.C- S.P.C, subject to certain exceptions permitted under applicable law.
                                    </p>
                                </div>
                            </div>

                            <p>
                                Exercising any of the mentioned rights does not entitle you to be discriminated against.
                                However, we may provide a different level of service or charge a different rate reasonably related to the value of your personal information.
                            </p>
                            <p>
                                In addition to the above, you can update or remove financial account information, and deactivate you’re your account on the Hayat In platform.
                                If you wish to exercise any of the rights set out above, please contact us at: <a href="mailto:Info@hayatinapp.com" className="email-link">Info@hayatinapp.com</a>
                            </p>
                            <p>
                                Under specific circumstances, data protection laws grant you the following rights (refer to Section 8 – Glossary below):
                            </p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Request access to your personal data.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Request correction of your personal data.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Request erasure of your personal data.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Object to the processing of your personal data.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Request restriction of processing your personal data.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        Request the transfer of your personal data.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        The right to withdraw consent.
                                    </p>
                                </div>
                            </div>

                            <p>
                                To exercise any of the rights mentioned above, please contact us at <a href="mailto:Info@hayatinapp.com" className="email-link">Info@hayatinapp.com</a>
                            </p>

                        </div>


                        <div className="defined-terms">
                            <h6>8. Your Rights and Choices and Legal Rights Under Data Protection Laws:</h6>
                            <p>
                                At Hayat In L.L.C- S.P.C, we believe in providing you with a personalized experience tailored to your preferences.
                                While we strive to enhance your experience by understanding your interests, we acknowledge your right to control the information you share with us and the communications you receive.
                                Here are key aspects of your rights and choices:
                            </p>
                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Access and Information:</strong> You have the right to know about the personal information collected over the past 12 months, including specific details, sources, purposes, and disclosures to third parties. This transparency extends to understanding if your data has been sold for business purposes.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Updates and Corrections:</strong> Your personal information must be accurate. You can update your information to ensure it reflects the latest details.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Portability:</strong> Request a portable copy of your personal information for your records.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Deletion Requests:</strong> You can request the deletion of your personal information, with certain exceptions mandated by applicable law.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Opt-Out of Disclosures:</strong> Opt-out of certain disclosures of your personal information for valuable consideration by contacting us at <a href="mailto:Info@hayatinapp.com" className="email-link">Info@hayatinapp.com</a>.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Non-Discrimination:</strong> We respect your choices. You will not face discrimination for exercising your rights, although different service levels may apply based on the value of your personal information.
                                    </p>
                                </div>
                            </div>
                            <p>
                                In addition to these choices, you can manage your communication preferences and deactivate your Hayat In L.L.C- S.P.C account at any time.<br></br>
                                Beyond operational choices, you have legal rights safeguarded by data protection laws:
                            </p>

                            <div className="defined-terms-list">
                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Access Request:</strong> Obtain a copy of the personal data we hold and ensure lawful processing.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Correction:</strong> Rectify incomplete or inaccurate data, ensuring its accuracy.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Erasure:</strong> Request the deletion or removal of personal data under specific circumstances.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Objection to Processing:</strong> Object to processing based on legitimate interests or for direct marketing purposes.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Restriction of Processing:</strong> Suspend data processing in certain scenarios, including verifying data accuracy or addressing legal claims.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Data Transfer:</strong> Request the transfer of your personal data in a machine-readable format.
                                    </p>
                                </div>

                                <div className="defined-terms-listcontent">
                                    <span> •</span>
                                    <p>
                                        <strong>Consent Withdrawal:</strong> Withdraw consent at any time without affecting prior lawful processing.
                                    </p>
                                </div>
                            </div>
                            <p>
                                Your privacy is crucial to us. Should you wish to exercise any of these rights or have further inquiries, please get in touch with us at <a href="mailto:Info@hayatinapp.com" className="email-link">Info@hayatinapp.com</a>
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>9. Privacy Practices of Third Parties</h6>
                            <p>
                                It is important to note that this Privacy Notice specifically addresses how Hayat In L.L.C- S.P.C handles and shares information during your use of the Service.
                                Other websites accessible through links from the Service, as well as our co-branded websites, may have their own privacy policies outlining their practices for collecting, using, and disclosing personal information.
                                Additionally, our business partners may have their own privacy policies.
                                We strongly recommend that you carefully review the privacy notices provided by these external entities before sharing any personal information or participating in sponsored offers or promotions.<br></br>
                                By consenting to this Privacy Policy, you acknowledge and authorize the sharing of your personal data, such as your name, email address, gender, date of birth, and nationality, with third parties for marketing purposes.
                                These third parties are bound by their own privacy policies, which apply when they collect information about you. However, they may provide you with options to opt out of having your information collected.
                            </p>

                            <p>
                                You have the choice to request us or third parties to cease sending you marketing messages at any time.
                                You can accomplish this by accessing the website and adjusting your marketing preferences through the relevant checkboxes.
                                Alternatively, you may use the opt-out links provided in any marketing message sent to you or reach out to us directly.<br></br>
                                It's important to note that opting out of marketing messages will not impact any personal data you have provided to us through product or service purchases, warranty registrations, product or service experiences, or other transactions.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>10.	Modification Of Purpose, Business Transfers, and Corporate Changes</h6>
                            <p>
                                Hayat In L.L.C- S.P.C has the right to share, transfer, or authorize any information related to the Service, including Personal Information, to a future owner, co-owner, or operator of the Service or any of its components.
                                Moreover, Hayat In L.L.C- O.P.C may disclose such information in association with a corporate merger, consolidation, or restructuring, the sale of all or a part of the company's stock and assets, or any other corporate change, including, but not limited to, any due diligence process.
                            </p>

                            <p>
                                We will only use your personal data for the specific purposes for which we originally collected it unless we determine that we need to use it for a different reason that aligns with the original purpose.
                                If we need to use your data for a new purpose, we will explain how it aligns with the original purpose upon request.
                                If we ever need to use your personal data for an unrelated purpose, we will inform you and provide an explanation of the legal basis that allows us to do so. Please note that there may be times when we are required or permitted by law to process your data without your knowledge or consent, but we will always do so in compliance with the rules mentioned above.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>11.	Cookies and Tracking Technologies </h6>
                            <p>
                                You have the option to configure your browser settings to either reject all cookies, accept only certain cookies, or receive notifications when a website attempts to set or access cookies.
                                However, it's important to note that disabling or rejecting cookies may result in certain parts of our websites being unavailable or functioning incorrectly.
                                For more details about the cookies utilized, please refer to Section 2 - How We Collect Your Personal Data, located above.
                            </p>

                            <p>
                                We and our partners employ various technologies, including cookies, pixels, and web beacons, to collect and store information when you use this website. Web beacons track specific behaviors such as email delivery, openings, and link clicks.
                                They enable us to gather details like your IP address, browser, email client type, and similar information.
                                Additionally, they assist in tracking website usage and traffic. Reports are generated when we send emails to you, allowing us to collect and analyze relevant information.
                                These cookies are stored on your hard drive but do not read its contents; they enable our website to recognize you upon your return. If you are on our mailing list and wish to be removed, please use the "Contact Us" section to submit your request.
                                If there is no unsubscribe button, kindly contact us to facilitate your removal.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>12.	Navigation and Clickstream Data</h6>
                            <p>
                                As you navigate through our website, we collect data on the pages you visit, the features you use, and how long you spend on each page.
                                This information is collected anonymously and cannot be linked to your personal identity.
                                We use this data to provide support and analyze your purchases, improve your website experience, comply with legal requirements, and deliver specialized advertising content and recommendations.
                                The information may be shared with our staff and third-party providers involved in completing your transaction, delivering your order, and supporting your use of the website.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>13.	Minors' Privacy Protection</h6>
                            <p>
                                The Service is crafted for a broad audience and is not designed for individuals under the age of 16.
                                Hayat In L.L.C- S.P.C has no verified knowledge of the sale of information pertaining to minors under 16 years of age.<br></br><br></br>
                                By using Hayat In application, you confirm that you are at least 16 years old and recognize that creating an account and completing purchases through the Service necessitates a minimum age of 18.
                            </p>
                            <p>
                                The Site and the Service are not aimed at individuals under the age of 16, and we do not knowingly gather or request information from anyone below this age.
                                Additionally, the Site prohibits individuals under the age of 16 from registering for the Service.
                                Should we discover that personal information has inadvertently been collected from someone under the age of 16 without the consent of a parent or guardian, we will promptly delete such information.
                                If you suspect that we have collected information from an individual under 16, please contact us at <a href="mailto:Info@hayatinapp.com" className="email-link">Info@hayatinapp.com</a>.
                            </p>
                            <p>
                                Our websites and mobile applications are not tailored for children under the age of sixteen (16), and we do not promote our products or services to such children.
                                We do not knowingly collect any data from children under the age of 16. Furthermore, our products and services are not accessible to individuals who are not of legal age to enter into a fully enforceable contract; an individual must be at least 18 years of age to engage in such transactions.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>14.	General Data Protection Rights GDPR</h6>
                            <p>We want to ensure that you are fully aware of your GDPR data protection rights. As a user, you have the following entitlements:</p>
                            <p>
                                1. The right to access - You can request copies of your personal data. However, we may charge a small fee for this service.
                            </p>

                            <p>
                                2. The right to rectification - You can request us to correct any information that you believe is inaccurate. Additionally, you have the right to request us to complete any incomplete information.
                            </p>

                            <p>
                                3. The right to erasure - You can request us to erase your personal data under certain conditions.
                            </p>

                            <p>
                                4. The right to restrict processing - You can request us to restrict the processing of your personal data under certain conditions.
                            </p>

                            <p>
                                5. The right to object to processing - You can object to our processing of your personal data under certain conditions.
                            </p>

                            <p>
                                6. The right to data portability - You can request us to transfer the data that we have collected to another organization, or directly to you, under certain conditions.
                            </p>
                            <p>If you make a request, we have one month to respond to you. If you want to exercise any of these rights, please contact us.</p>
                        </div>

                        <div className="defined-terms">
                            <h6>15.	Protection of Your Personal Information</h6>
                            <p>
                                Our website has secure pages that collect user information, and any critical data is stored in encrypted form.
                                We employ various technical and management practices to safeguard the confidentiality, security, and integrity of all data stored on our system.
                                Our servers are equipped with Secure Sockets Layer (SSL) and encryption technology that is compatible with popular web browsers such as Netscape Navigator, Microsoft Internet Explorer, Firefox, Safari, and Chrome.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>16. Modifications To This Privacy Policy</h6>
                            <p>
                                This Privacy Policy may undergo periodic updates to align with our business operations and legal obligations.
                                In the event of any revisions to our Privacy Policy, the updated version will be published on this webpage
                                and within the privacy sections of any pertinent platforms.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>17. Verifying, Updating, and Amending Personal Information</h6>
                            <p>
                                To verify, update, or modify your personal information on our app, please log in to your account and select
                                "My Account". From there, you can access "Account Info" and "Saved Address" to update any information as needed.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>18. Information about the Services We Offer</h6>
                            <p>
                                We strive to provide you with the best service possible and to achieve this, we may periodically send you
                                information about our products, services, discounts, promotions, and campaigns that we believe may interest you.
                                We will only send you marketing communications if you have given us your consent.
                                If you no longer wish to receive these details and would like to unsubscribe from marketing communications,
                                you can contact us via email at <a href="mailto:Info@hayatinapp.com" className="email-link">Info@hayatinapp.com</a> or change your relevant settings by logging into your account
                                and clicking the "My Account" link on the user main page.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>19. How to Delete Your Account</h6>
                            <p>
                                At Hayat In application, you have the option to delete your account using our mobile application.
                                However, please note that if there are any pending transactions or outstanding amounts due,
                                you will not be able to delete your account.
                                Before deleting your account, you must complete all pending transactions and/or payments.<br></br><br></br>
                                To delete your account through our mobile application, please follow these simple steps:
                            </p>
                            <p>1. Open the Hayat In mobile app on your device.</p>

                            <p>2. Go to the 'Settings' menu, which is located at the top right corner of the home screen.</p>

                            <p>3. Select 'My Account.'</p>

                            <p>4. Click on the 'Delete Account' option.</p>

                            <p>5. Press OK to confirm and complete the deletion process.</p>
                            <p>
                                Please keep in mind that when you delete your account, your personal data will also be deleted.
                                However, we may be required to keep some of your information if we process it as part of our legal obligations, or in pursuit of our own (or a third party’s legitimate interests) such as the assertion of, or defense against, legal claims, preventing fraud or protecting ourselves or others against abusive behavior.
                                Once your data is deleted from the mobile app, it will be permanently removed from our systems and cannot be recovered.
                                If you have any questions, please contact our customer support.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>20.	Entire Agreement</h6>
                            <p>
                                Entire Agreement.
                                This Agreement, our <a href="#privacy policy" className="hayat-link">Terms of Use</a> , <a href="#privacy policy" className="hayat-link">Terms of Sale</a>, <a href="#privacy policy" className="hayat-link">Rules of Use</a>
                                , <a href="#privacy policy" className="hayat-link">Terms of reservation</a>, <a href="#privacy policy" className="hayat-link">End-user Licence agreement</a>, and our <a href="#privacy policy" className="hayat-link">Privacy Policy</a> constitute the entire agreement between you and Hayat In L.L.C- S.P.C with respect to the Application and supersede all prior or contemporaneous understandings and agreements, whether written or oral, with respect to the Application.
                            </p>
                        </div>

                        <div className="defined-terms">
                            <h6>21.	Contact Us</h6>
                            <p>
                                Please contact us if you have any questions or comments about our privacy practices or this Privacy Notice.
                                You can reach us online at <a href="mailto:Info@hayatinapp.com" className="email-link">Info@hayatinapp.com</a>
                            </p>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default PrivacyPolicy